import { useMemo } from 'react';
import { Box } from '@chakra-ui/react';
import { Document } from '@mercator-gcp/types/elastic_search_service/documents/DocumentDetailFilterResponse';
import { EmptyField } from 'components/elements//EmptyField';
import Tooltip from 'components/elements/Tooltip';
import { FlexColumn } from 'components/layout/FlexColumn/FlexColumn';
import { toSentenceCase } from 'utils/misc';

const containerStyle = { gap: 'padding_4' };

const nameStyle = {
  display: '-webkit-box',
  overflow: 'hidden',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 1, // Limit text to 1 lines
  textOverflow: 'ellipsis',
  whiteSpace: 'normal',
};

const descriptionStyle = {
  display: '-webkit-box',
  overflow: 'hidden',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 3, // Limit text to 3 lines
  textOverflow: 'ellipsis',
  whiteSpace: 'normal',
};

type ViewProjectProps = {
  description?: Document['description'] | null;
  name?: Document['name'] | null;
};

const DescriptionCell = ({ name, description }: ViewProjectProps) => {
  const formattedDescription = useMemo(() => {
    return description ? toSentenceCase(description) : '';
  }, [description]);

  if (!formattedDescription && !name) {
    return <EmptyField />;
  }

  return (
    <Tooltip tooltipText={formattedDescription} fullWidth>
      <FlexColumn sx={containerStyle}>
        {name && <Box sx={nameStyle}>{name}</Box>}
        {formattedDescription && <Box sx={descriptionStyle}>{formattedDescription}</Box>}
      </FlexColumn>
    </Tooltip>
  );
};

export default DescriptionCell;
